import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 min
      gcTime: 300_000,   // 5 min
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
